import styled from 'styled-components';
import { Table } from 'antd';
const FONT_FAMILY = `'Inter', 'Segoe UI', Arial, sans-serif`;
export const TableWrapper = styled.div `
  width: 100%;
  overflow-x: auto;
  background: transparent;
`;
const StyledTable = styled(Table) `
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(60,60,60,0.04);
  border: 1px solid #e5e7eb;
  font-family: ${FONT_FAMILY};
  min-width: 800px;
  .ant-table-thead > tr > th {
    background: #f9fafb;
    font-weight: 600;
    font-size: 15px;
    color: #222;
    border-bottom: 1px solid #ececec;
    letter-spacing: 0.01em;
    padding: 18px 20px;
    font-family: ${FONT_FAMILY};
  }
  .ant-table-tbody > tr > td {
    font-size: 15px;
    color: #222;
    background: #fff;
    border-bottom: 1px solid #f3f3f3;
    padding: 18px 20px;
    transition: background 0.2s;
    height: 60px;
    font-family: ${FONT_FAMILY};
  }
  .ant-table-tbody > tr:nth-child(even) > td {
    background: #f7f8fa;
  }
  .ant-table-tbody > tr:hover > td {
    background: #f2f6fa !important;
  }
  .ant-table-tbody > tr:last-child > td {
    border-bottom: none;
  }
  @media (max-width: 900px) {
    min-width: 600px;
    font-size: 14px;
    .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
      font-size: 14px;
      padding: 12px 10px;
    }
  }
  @media (max-width: 600px) {
    min-width: 500px;
    font-size: 13px;
    .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
      font-size: 13px;
      padding: 8px 6px;
    }
  }
`;
export default StyledTable;
